(window.theme = window.theme || {}),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function(e, t) {
    return function() {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function(e, t) {
    for (var s = 0, r = e.options.length; s < r; s++) {
      var i = e.options[s];
      if (t == i.value || t == i.innerHTML) return (e.selectedIndex = s);
    }
  }),
  (Shopify.addListener = function(e, t, s) {
    e.addEventListener ? e.addEventListener(t, s, !1) : e.attachEvent("on" + t, s);
  }),
  (Shopify.postLink = function(e, t) {
    var s,
      r = (t = t || {}).method || "post",
      i = t.parameters || {},
      n = document.createElement("form");
    for (s in (n.setAttribute("method", r), n.setAttribute("action", e), i)) {
      var a = document.createElement("input");
      a.setAttribute("type", "hidden"), a.setAttribute("name", s), a.setAttribute("value", i[s]), n.appendChild(a);
    }
    document.body.appendChild(n), n.submit(), document.body.removeChild(n);
  }),
  (Shopify.CountryProvinceSelector = function(e, t, s) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(s.hideElement || t)),
      Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function() {
      var e = this.provinceEl.getAttribute("data-default");
      e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function(e) {
      var t = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
        s = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), s && 0 == s.length)) this.provinceContainer.style.display = "none";
      else {
        for (var r, i = 0; i < s.length; i++) ((r = document.createElement("option")).value = s[i][0]), (r.innerHTML = s[i][1]), this.provinceEl.appendChild(r);
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function(e) {
      for (; e.firstChild;) e.removeChild(e.firstChild);
    },
    setOptions: function(e, t) {
      var s = 0;
      for (t.length; s < t.length; s++) {
        var r = document.createElement("option");
        (r.value = t[s]), (r.innerHTML = t[s]), e.appendChild(r);
      }
    },
  }),
  (theme.config = {
    mediaQueries: {
      landscapeAll: "screen and (orientation: landscape)",
      landscape: "screen and (orientation: landscape), screen and (min-width: 48rem)",
      belowTablet: "screen and (max-width: 47.99rem)",
      tablet: "screen and (min-width: 48rem)",
      belowLaptop: "screen and (max-width: 63.99rem)",
      laptop: "screen and (min-width: 64rem)",
      belowDesktop: "screen and (max-width: 64rem)",
      desktop: "screen and (min-width: 64.01rem)",
      belowWidescreen: "screen and (max-width: 79.99rem)",
      widescreen: "screen and (min-width: 80rem)",
      belowExtrawide: "screen and (max-width: 89.99rem)",
      extrawide: "screen and (min-width: 90rem)",
    },
    money: { format: `${window.currency.symbol || "$"}{{amount}}`, currencySymbols: { USD: "$", CAD: "$", EUR: "€", CRC: "₡", GBP: "£", ILS: "₪", INR: "₹", JPY: "¥", KRW: "₩", NGN: "₦", PHP: "₱", PLN: "zł", PYG: "₲", THB: "฿", UAH: "₴", VND: "₫" } },
    upsellLimit: 6,
  }),
  (theme.utils = {
    subscriptions: {
      subscribers: {},
      subscribe(e, t) {
        return (
          void 0 === theme.utils.subscriptions.subscribers[e] && (theme.utils.subscriptions.subscribers[e] = []),
          (theme.utils.subscriptions.subscribers[e] = [...theme.utils.subscriptions.subscribers[e], t]),
          function() {
            theme.utils.subscriptions.subscribers[e] = theme.utils.subscriptions.subscribers[e].filter((e) => e !== t);
          }
        );
      },
      publish(e, t) {
        theme.utils.subscriptions.subscribers[e] &&
          theme.utils.subscriptions.subscribers[e].forEach((e) => {
            e(t);
          });
      },
    },
    a11y: {
      getFocusableElements(e) {
        return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
      },
      _trapFocusHandlers: {},
      trapFocus(t, e = t) {
        var s = theme.utils.a11y.getFocusableElements(t),
          r = s[0],
          i = s[s.length - 1];
        theme.utils.a11y.removeTrapFocus(),
          (theme.utils.a11y._trapFocusHandlers.focusin = (e) => {
            (e.target !== t && e.target !== i && e.target !== r) || document.addEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown);
          }),
          (theme.utils.a11y._trapFocusHandlers.focusout = function() {
            document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown);
          }),
          (theme.utils.a11y._trapFocusHandlers.keydown = function(e) {
            "TAB" === e.code.toUpperCase() && (e.target !== i || e.shiftKey || (e.preventDefault(), r.focus()), e.target === t || e.target === r) && e.shiftKey && (e.preventDefault(), i.focus());
          }),
          document.addEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout),
          document.addEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin),
          e.focus();
      },
      removeTrapFocus(e = null) {
        document.removeEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin),
          document.removeEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout),
          document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown),
          e && e.focus();
      },
    },
    prepareTransition(e) {
      e.addEventListener("transitionend", () => {
        e.classList.remove("is-transitioning");
      });
      let t = 0;
      const s = getComputedStyle(e);
      ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"].forEach((e) => (t = t || parseFloat(s.getPropertyValue(e)))), 0 != t && (e.classList.add("is-transitioning"), e.offsetWidth);
    },
    defaultTo: function(e, t) {
      return null == e || e != e ? t : e;
    },
    formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var s = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        a = t || theme.config.money.format;
      function r(e, t, s, r) {
        if (((t = theme.utils.defaultTo(t, 2)), (s = theme.utils.defaultTo(s, ",")), (r = theme.utils.defaultTo(r, ".")), isNaN(e) || null == e)) return 0;
        (t = (e = (e / 100).toFixed(t)).split(".")), (e = t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s));
        let i = t[1] ? r + t[1] : "";
        return e + (i = "no_trailing_zeros" == a.match(n)[1] && ".00" == i ? "" : i);
      }
      switch (a.match(n)[1]) {
        case "amount":
          s = r(e, 2);
          break;
        case "amount_no_decimals":
          s = r(e, 0);
          break;
        case "amount_with_space_separator":
          s = r(e, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = r(e, 0, ",", ".");
          break;
        case "amount_no_decimals_with_space_separator":
          s = r(e, 0, " ");
          break;
        case "no_trailing_zeros":
          s = r(e, 2);
      }
      return a.replace(n, s);
    },
    serializeForm: (e) => {
      var t = {},
        s = new FormData(e);
      for (const i of s.keys()) {
        var r = /(?:^(properties\[))(.*?)(?:\]$)/;
        r.test(i) ? ((t.properties = t.properties || {}), (t.properties[r.exec(i)[2]] = s.get(i))) : (t[i] = s.get(i));
      }
      return JSON.stringify(t);
    },
    debounce(t, s) {
      let r;
      return (...e) => {
        clearTimeout(r), (r = setTimeout(() => t.apply(this, e), s));
      };
    },
    getSiblings(e, t) {
      var s,
        r = [];
      let i;
      for (s of (i = t ? e.parentNode.querySelectorAll(":scope > " + t) : e.parentNode.children)) s !== e && r.push(s);
      return r;
    },
    refreshElements(e, t, s) {
      e.forEach((e) => {
        const n = t.querySelectorAll(e);
        s.querySelectorAll(e).forEach((e, t) => {
          var s, r, i;
          n[t]
            ? null != e.getAttribute("js-accordion-item")
              ? ((s = e.querySelector("[js-accordion-header]").getAttribute("aria-expanded")),
                (r = e.querySelector("[js-accordion-content]").getAttribute("aria-hidden")),
                (i = n[t]).querySelector("[js-accordion-header]").setAttribute("aria-expanded", s),
                i.querySelector("[js-accordion-content]").setAttribute("aria-hidden", r),
                (e.innerHTML = i.innerHTML))
              : (e.innerHTML = n[t].innerHTML)
            : e.remove();
        });
      });
    },
    handleize(e) {
      return e
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    },
    getCookie(e) {
      for (var t = e + "=", s = decodeURIComponent(document.cookie).split(";"), r = 0; r < s.length; r++) {
        for (var i = s[r]; " " == i.charAt(0);) i = i.substring(1);
        if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
      }
      return "";
    },
    setCookie(e, t, s) {
      var r = new Date(),
        s = (r.setTime(r.getTime() + 24 * s * 60 * 60 * 1e3), "expires=" + r.toUTCString());
      document.cookie = e + "=" + t + ";" + s + ";path=/";
    },
  });
class FocusableWidget extends HTMLElement {
  constructor(e = {}) {
    if ((super(), !e.name)) throw new Error(`Focusable Widget(${e.name}) must have a name`);
    if (!this.id) throw new Error(e.name + " must have an id");
    if (!e.background) throw new Error(`Focusable Widget(${e.name}) must have a background`);
    (this._clientConfig = e), this._init(e);
  }
  open = () => {
    if (!this._isOpen) return this._closeFocusableWidgets(), this.toggle();
  };
  close = () => {
    if (this._isOpen) return this.toggle();
  };
  toggle = () => (
    theme.utils.prepareTransition(this),
    this._toggleClasses(),
    this._toggleAccessibilityAttributes(),
    this._isOpen ? (theme.utils.a11y.removeTrapFocus(this), this._unbindEvents(), this._dispatchEvents(this._events.close, ["close"])) : (theme.utils.a11y.trapFocus(this), this._bindEvents(), this._dispatchEvents(this._events.open, ["open"])),
    (this._isOpen = !this._isOpen),
    this
  );
  reinitWidget = () => {
    this._init(this._clientConfig);
  };
  get isOpen() {
    return this._isOpen;
  }
  _init({ name: e, background: t, widgetOpenClasses: s = [], bodyOpenClasses: r = [], attributes: i = {} }) {
    (this._name = e),
      (this._isOpen = !1),
      (this._selectors = { background: t, open: this.getAttribute("open"), close: this.getAttribute("close") }),
      (this._nodes = { background: document.querySelector(this._selectors.background) }),
      (this._events = { open: ["focusable-widget:open", e + ":open", this.id + ":open"], close: ["focusable-widget:close", e + ":close", this.id + ":close"] }),
      (this._config = {
        open: document.querySelectorAll(this._selectors.open),
        close: document.querySelectorAll(this._selectors.close),
        attributes: { "data-focusable-widget": "true", "aria-hidden": "true", tabindex: 0, ...i },
        widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(s),
        bodyOpenClasses: ["js-focusable-widget-open", `js-${e}-open`, this.getAttribute("body-open-class")].concat(r),
      }),
      this._validateConfig(),
      this._addAccessibilityAttributes(),
      this._setupListeners();
  }
  _validateConfig() {
    if (((this._config.open && this._config.open.length) || console.warn(`WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`), !this._config.close || !this._config.close.length))
      throw new Error(`${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`);
  }
  _setupListeners() {
    this._config.open.forEach((e) => e.addEventListener("click", this._open.bind(this))), this._config.close.forEach((e) => e.addEventListener("click", this._close.bind(this))), this.addEventListener("click", (e) => e.stopPropagation());
  }
  _open(e) {
    e && (e.preventDefault(), e.stopPropagation()), this.open();
  }
  _close = (e) => {
    e && (e.preventDefault(), e.stopPropagation()), this.close();
  };
  _closeFocusableWidgets() {
    document.querySelectorAll("[data-focusable-widget].open").forEach((e) => e.close());
  }
  _dispatchEvents(e, t) {
    e.forEach((e) => document.dispatchEvent(new CustomEvent(e))), t && t.length && t.forEach((e) => this.dispatchEvent(new CustomEvent(e)));
  }
  _bindEvents() {
    document.addEventListener("keyup", this._onKeyUp), this._nodes.background.addEventListener("click", this._close), this._nodes.background.addEventListener("touchmove", this._onTouchMove);
  }
  _unbindEvents() {
    document.removeEventListener("keyup", this._onKeyUp), this._nodes.background.removeEventListener("click", this._close), this._nodes.background.removeEventListener("touchmove", this._onTouchMove);
  }
  _toggleClasses() {
    this._isOpen
      ? (this._config.bodyOpenClasses.forEach((e) => {
        e && document.body.classList.remove(e);
      }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.remove(e);
        }))
      : (this._config.bodyOpenClasses.forEach((e) => {
        e && document.body.classList.add(e);
      }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.add(e);
        }));
  }
  _toggleAccessibilityAttributes() {
    this._isOpen
      ? (this.setAttribute("aria-hidden", "true"), this.setAttribute("tabindex", "-1"), this._config.open.forEach((e) => e.setAttribute("aria-expanded", "false")), this._config.close.forEach((e) => e.setAttribute("aria-expanded", "false")))
      : (this.setAttribute("aria-hidden", "false"), this.setAttribute("tabindex", "0"), this._config.open.forEach((e) => e.setAttribute("aria-expanded", "true")), this._config.close.forEach((e) => e.setAttribute("aria-expanded", "true")));
  }
  _addAccessibilityAttributes() {
    var e = (e) => {
      e.setAttribute("tabindex", "0"), e.setAttribute("aria-expanded", "false"), e.setAttribute("aria-controls", this.id);
    };
    for (const t in this._config.attributes) this.setAttribute(t, this._config.attributes[t]);
    this._config.open.forEach(e), this._config.close.forEach(e);
  }
  _onKeyUp = (e) => {
    "ESCAPE" === e.code.toUpperCase() && this.close();
  };
  _onTouchMove = () => !1;
}
class Squiggly extends HTMLElement {
  constructor() {
    super(), (this._selectors = { main: "[js-squiggly-main]", inner: "[js-squiggly-inner]" });
  }
  connectedCallback() {
    (this.inner = this.querySelector(this._selectors.inner)), this._setWidth();
  }
  _setWidth = () => {
    var e = this.offsetWidth,
      e = (this.style.setProperty("--link-width", "calc(-100% + " + e + "px)"), ".squiggly-link:hover .Squiggly-underline-inner-child {transform:translate(var(--link-width))}"),
      t = ".squiggly-link:focus .Squiggly-underline-inner-child {transform:translate(var(--link-width))}",
      s = ".squiggly-link:hover .Squiggly-underline-inner-gc {transform:translate(var(--link-width))}",
      r = ".squiggly-link:focus .Squiggly-underline-inner-gc {transform:translate(var(--link-width))}",
      i = document.createElement("style");
    i.styleSheet
      ? ((i.styleSheet.cssText = e), (i.styleSheet.cssText = t), (i.styleSheet.cssText = s), (i.styleSheet.cssText = r))
      : (i.appendChild(document.createTextNode(e)), i.appendChild(document.createTextNode(t)), i.appendChild(document.createTextNode(s)), i.appendChild(document.createTextNode(r))),
      document.getElementsByTagName("head")[0].appendChild(i);
  };
}
class Drawer extends FocusableWidget {
  constructor() {
    super({ name: "drawer", background: ".drawer-background" });
    var e = this.getAttribute("position");
    if (!e) throw new Error("drawer must have position attribute");
    (this._position = e), this._config.bodyOpenClasses.push(`js-drawer-${e}-open`), (this._clientConfig.bodyOpenClasses = [`js-drawer-${e}-open`]);
  }
  get position() {
    return this._position;
  }
}
class Modal extends FocusableWidget {
  constructor() {
    super({ name: "modal", background: ".modal-background", bodyOpenClasses: "js-modal-open" });
  }
}
class Accordion extends HTMLElement {
  constructor() {
    super(), (this._selectors = { accordion: "[js-accordion]", accordionItem: "[js-accordion-item]", accordionHeader: "[js-accordion-header]", accordionContent: "[js-accordion-content]" });
  }
  connectedCallback() {
    (this.buttons = this.querySelectorAll(this._selectors.accordionHeader)),
      this.buttons.forEach((e) => {
        e.addEventListener("click", this._toggleContent);
      }),
      (this.content = this.querySelectorAll(this._selectors.accordionContent));
  }
  _toggleContent = (e) => {
    e.stopImmediatePropagation();
    var e = e.currentTarget,
      t = this.querySelector("#" + e.getAttribute("aria-controls")),
      s = theme.utils.getSiblings(e.parentElement, this._selectors.accordionItem);
    "false" == e.getAttribute("aria-expanded")
      ? (e.setAttribute("aria-expanded", !0),
        theme.utils.prepareTransition(t),
        this._expandSection(t),
        this.dataset.manualCollapse ||
        s.forEach((e) => {
          var t = e.querySelector(this._selectors.accordionHeader),
            e = e.querySelector("#" + t.getAttribute("aria-controls"));
          "true" == t.getAttribute("aria-expanded") && (t.setAttribute("aria-expanded", !1), this._collapseSection(e));
        }))
      : (e.setAttribute("aria-expanded", !1), this._collapseSection(t));
  };
  _collapseSection(e) {
    e.setAttribute("aria-hidden", !0);
  }
  _expandSection(e) {
    e.setAttribute("aria-hidden", !1);
  }
}
class Tabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this._elements = { tabs: this.querySelectorAll("[js-tab]"), tabList: this.querySelectorAll("[js-tab-list]"), tabPanel: this.querySelectorAll("[js-tab-panel]") }), this._tabEventListener(), this._tabListListener();
  }
  _tabEventListener = () => {
    var e = this._elements["tabs"];
    e.forEach((e) => e.addEventListener("click", this._showTabPanel));
  };
  _showTabPanel = (e) => {
    var t = this._elements["tabs"];
    for (let e = 0; e < t.length; e++) t[e].setAttribute("aria-selected", "false");
    e.target.setAttribute("aria-selected", "true");
    var e = e.target.getAttribute("aria-controls"),
      s = document.querySelectorAll("[role=tabpanel]");
    for (let e = 0; e < s.length; e++) s[e].setAttribute("aria-hidden", "true");
    document.getElementById(e).setAttribute("aria-hidden", "false");
  };
  _tabListListener = () => {
    var e = this._elements["tabList"];
    e.forEach((e) => e.addEventListener("keydown", this._tabListKeydown));
  };
  _tabListKeydown = (e) => {
    37 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      38 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      39 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault()),
      40 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault());
  };
}
class Carousel extends HTMLElement {
  constructor() {
    super(), (this.selectors = { carousel: "[js-carousel]" }), (this.options = { loop: !0, slidesPerView: "auto", grabCursor: !0, centeredSlides: !1, navigation: !1, pagination: !1 });
  }
  connectedCallback() {
    var e = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    (this.options = Object.assign(this.options, e)), this._initCarousel();
  }
  _initCarousel() {
    let e = "#" + this.querySelector(this.selectors.carousel).id;
    void 0 !== this.dataset.init
      ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
        match: function() {
          this.carousel = new Swiper(e, this.options);
        }.bind(this),
        unmatch: function() {
          this.carousel.el.classList.contains("swiper-initialized") && this.carousel.destroy(!0, !0);
        }.bind(this),
      })
      : (this.carousel = new Swiper(e, this.options));
  }
}
class SiteHeader extends HTMLElement {
  constructor() {
    super(), (this._selectors = { header: "#shopify-section-header", openButton: "[js-open-mobile-nav]", closeButton: "[js-close-mobile-nav]" });
  }
  connectedCallback() {
    (this.header = document.querySelector(this._selectors.header)),
      (this.openButton = document.querySelector(this._selectors.openButton)),
      (this.closeButton = document.querySelector(this._selectors.closeButton)),
      this._setVariables(),
      this._setListeners(),
      this._watchWindowResize();
  }
  _setListeners = (e) => {
    document.addEventListener("MobileNavDrawer:open", this._openDrawer), document.addEventListener("MobileNavDrawer:close", this._closeDrawer);
  };
  _openDrawer = () => {
    this.openButton.classList.add("hidden"), this.closeButton.classList.remove("hidden");
  };
  _closeDrawer = () => {
    this.openButton.classList.remove("hidden"), this.closeButton.classList.add("hidden");
  };
  _watchWindowResize = (e) => {
    window.addEventListener("resize", this._setVariables);
  };
  _setVariables = (e) => {
    document.documentElement.style.setProperty("--header-height", this.header.clientHeight + "px");
  };
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (e) => {
        e.preventDefault(), (this.closest("cart-items") || this.closest("cart-drawer-items")).updateQuantity(this.dataset.index, 0);
      });
  }
}
class CartItems extends HTMLElement {
  constructor() {
    super();
    var e = theme.utils.debounce((e) => {
      this.onChange(e);
    }, 300);
    this.addEventListener("change", e.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.cartUpdateUnsubscriber = theme.utils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (e) => {
      "cart-items" !== e.source && this.onCartUpdate();
    })),
      this.querySelectorAll("[js-cart-upsell-add]").forEach((e) => {
        e.addEventListener("click", this.addUpsell.bind(this));
      }),
      this.checkCart();
  }
  getCartContents() {
    return fetch("" + routes.cart_url, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" } })
      .then((e) => e.json())
      .then((e) => e)
      .catch((e) => {
        console.error("Error:", e);
      });
  }
  async checkCart() {
    var e = await this.getCartContents();
    let t = !1,
      s = 0;
    e.items.forEach((e) => {
      e.properties._upsell ? (t = !0) : (s += e.quantity);
    }),
      0 == s &&
      t &&
      ((e = { sections: this.getSectionsToRender().map((e) => e.section) }),
        fetch("" + routes.cart_clear_url, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify(e) })
          .then((e) => e.json())
          .then((e) => (document.querySelector("cart-drawer").renderContents(e), e))
          .catch((e) => {
            console.error("Error:", e);
          }));
  }
  addUpsell(e) {
    e.preventDefault();
    e = { items: [{ id: parseInt(e.target.dataset.variantId), quantity: 1, properties: { _upsell: e.target.dataset.property } }], sections: this.getSectionsToRender().map((e) => e.section) };
    fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(e) })
      .then((e) => e.json())
      .then((e) => {
        document.querySelector("cart-drawer").renderContents(e);
      })
      .catch((e) => {
        console.error("Error:", e);
      });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(e) {
    this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch(routes.cart_url + "?section_id=cart__main")
      .then((e) => e.text())
      .then((e) => {
        e = new DOMParser().parseFromString(e, "text/html").querySelector("cart-items");
        this.innerHTML = e.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [{ id: "CartPage-CartItems", section: document.getElementById("CartPage-CartItems").dataset.id, selector: "[js-cart-page-contents]" }];
  }
  updateQuantity(a, e, o) {
    this.enableLoading(a);
    e = JSON.stringify({ line: a, quantity: e, sections: this.getSectionsToRender().map((e) => e.section) });
    fetch("" + routes.cart_change_url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: e })
      .then((e) => e.text())
      .then((t) => {
        const s = JSON.parse(t);
        var t = document.getElementById("Quantity-" + a) || document.getElementById("Drawer-quantity-" + a),
          r = document.querySelectorAll("[js-cart-item]");
        if (s.errors) (t.value = t.getAttribute("value")), this.updateLiveRegions(a, s.errors);
        else {
          var i = document.querySelector("cart-drawer"),
            n =
              (this.getSectionsToRender().forEach((e) => {
                (document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(s.sections[e.section], e.selector);
              }),
                s.items[a - 1] ? s.items[a - 1].quantity : void 0);
          let e = "";
          r.length === s.items.length && n !== parseInt(t.value) && (e = void 0 === n ? "" : `You can only add ${n} of this item to your cart.`), this.updateLiveRegions(a, e);
          r = document.getElementById("CartItem-" + a) || document.getElementById("CartDrawer-Item-" + a);
          r && r.querySelector(`[name="${o}"]`)
            ? i
              ? theme.utils.a11y.trapFocus(i, r.querySelector(`[name="${o}"]`))
              : r.querySelector(`[name="${o}"]`).focus()
            : 0 === s.item_count && i
              ? theme.utils.a11y.trapFocus(i.querySelector("[js-empty-cart]"), i.querySelector("[js-cart-continue-link]"))
              : document.querySelector("[js-cart-item]") && i && theme.utils.a11y.trapFocus(i, document.querySelector("[js-cart-item-image]")),
            theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
        }
      })
      .catch((e) => {
        console.log(e), this.querySelectorAll(".loading-overlay").forEach((e) => e.classList.add("hidden")), ((document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")).textContent = "");
      })
      .finally(() => {
        this.disableLoading(a);
      });
  }
  updateLiveRegions(e, t) {
    e = document.getElementById("Line-item-error-" + e) || document.getElementById("CartDrawer-LineItemError-" + e);
    e && (e.innerHTML = t);
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }
  enableLoading(e) {
    (document.getElementById("CartPage-CartItems") || document.getElementById("CartDrawer-CartItems")).classList.add("cart__items--disabled");
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach((e) => e.setAttribute("loading", "")), document.activeElement.blur();
  }
  disableLoading(e) {
    (document.getElementById("CartPage-CartItems") || document.getElementById("CartDrawer-CartItems")).classList.remove("cart__items--disabled");
    var t = this.querySelectorAll(`#CartItem-${e} loading-spinner`),
      e = this.querySelectorAll(`#CartDrawer-Item-${e} loading-spinner`);
    [...t, ...e].forEach((e) => e.removeAttribute("loading"));
  }
}
class CartNote extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener(
        "change",
        debounce((e) => {
          e = JSON.stringify({ note: e.target.value });
          fetch("" + routes.cart_update_url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: e });
        }, ON_CHANGE_DEBOUNCE_TIMER)
      );
  }
}
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
  renderContents(t) {
    (this.productId = t.id),
      this.getSectionsToRender().forEach((e) => {
        (e.selector ? document.querySelector(e.selector) : document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector);
      });
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }
  getSectionsToRender() {
    return [{ id: "cart", selector: "#cart" }, { id: "cart-count" }];
  }
  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "cart", section: "cart", selector: "[js-cart-drawer-contents]" },
      { id: "cart-count", section: "cart-count", selector: ".shopify-section" },
    ];
  }
}
class ProductOptions extends HTMLElement {
  constructor() {
    super(), (this._selectors = { singleOptionSelector: "[js-product-option-selector]" }), (this._events = { change: "variant:change", fetchBefore: "variant:fetch:before", fetchAfter: "variant:fetch:after", fetchError: "variant:fetch:error" });
  }
  connectedCallback() {
    var e;
    (this._handle = this.dataset.productHandle),
      (this._masterSelect = document.getElementById(this.dataset.masterSelectId)),
      (this._checkAvailableOptions = !this.hasAttribute("data-disable-option-binding")),
      (this._optionSelectors = [...this.querySelectorAll(this._selectors.singleOptionSelector)]),
      this._checkAvailableOptions && ((this._availableValues = {}), (this._lastSelectedOption = null), (this._option1Values = this._option2Values = null)),
      this.dataset.product && (e = document.getElementById(this.dataset.product)) && (this._product = JSON.parse(e.innerHTML)),
      this._product && ((this._currentVariant = this._getVariantFromOptions()), this._checkAvailableOptions) && this._setupOptionsAvailability(this._product),
      (this._product || this._handle) && this._setupListeners();
  }
  set product(e) {
    (this._product = e), this.disconnectedCallback(), this.connectedCallback();
  }
  _setupListeners() {
    this._optionSelectors.forEach((e) => e.addEventListener("change", this._handleOptionChange));
  }
  _getVariantFromOptions() {
    if (this._product) {
      const s = this._getCurrentOptions();
      var e = this._product["variants"];
      return e.find((t) =>
        s.every(
          (e) =>
            e.value ===
            t[e.index]
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
        )
      );
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((e) => {
        var t = e.getAttribute("type"),
          s = {};
        return (("radio" !== t && "checkbox" !== t) || !!e.checked) && ((s.value = e.value), (s.index = e.dataset.index), s);
      })
      .filter((e) => e);
  }
  _setupOptionsAvailability(e) {
    (this._option1Values = new Set()),
      (this._option2Values = new Set()),
      e.variants.forEach((e) => {
        var { option1: e, option2: t } = e;
        e &&
          this._option1Values.add(
            e
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
          ),
          t &&
          this._option2Values.add(
            t
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "")
          );
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      this._optionSelectors.forEach((e) => {
        null == this._lastSelectedOption && e.checked && (this._lastSelectedOption = { key: e.dataset.index, value: e.value });
      }),
      (this._availableValues = this._getAvailableValues(this._product, this._lastSelectedOption)),
      this._refreshValuesUI(this._availableValues);
  }
  _handleOptionChange = (t) => {
    this._product
      ? this._updateVariant(t)
      : this._fetchProduct(this._handle)
        .then((e) => {
          (this._product = e), this._checkAvailableOptions && this._setupOptionsAvailability(this._product), this._updateVariant(t);
        })
        .catch((e) => console.log(e));
  };
  _updateVariant(e) {
    this._lastSelectedOption = { key: e.target.dataset.index, value: e.target.value };
    var t,
      s,
      e = this._getVariantFromOptions();
    this.dispatchEvent(new CustomEvent(this._events.change, { detail: { variant: e, priceChange: this._hasPriceChanged(e) }, bubbles: !0 })),
      this._checkAvailableOptions && ((t = this._getAvailableValues(this._product, this._lastSelectedOption)), (s = this._getDifference(this._availableValues, t)), this._refreshValuesUI(s), (this._availableValues = t)),
      this.hasAttribute("data-enable-history-state") && this._updateHistoryState(e),
      this._masterSelect && this._updateMasterSelect(e),
      (this._currentVariant = e);
  }
  _hasPriceChanged(e) {
    return !(!e || !this._currentVariant || (e.price === this._currentVariant.price && e.compare_at_price === this._currentVariant.compare_at_price));
  }
  _getAvailableValues(s, r) {
    if (r) {
      const i = {};
      var e = ["option1", "option2"],
        t = { option1: this._option1Values, option2: this._option2Values };
      const n = e.find((e) => e !== r.key);
      return (
        t[n].forEach((t) => {
          var e = s.variants.findIndex(
            (e) =>
              e[r.key]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === r.value &&
              e[n]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === t &&
              e.available
          );
          i[t] = 0 <= e;
        }),
        i
      );
    }
    return s.variants.reduce((e, t) => {
      var { option1: t, option2: s } = t;
      return t && (e[t] = !0), s && (e[s] = !0), e;
    }, {});
  }
  _refreshValuesUI(e) {
    for (const s in e) {
      var t = this.querySelector(`[value="${s}"]`);
      t && (t.disabled = !e[s]);
    }
  }
  _updateHistoryState(e) {
    history.replaceState && e && ((e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id), window.history.replaceState({ path: e }, "", e));
  }
  _updateMasterSelect(e) {
    e && (this._masterSelect.value = e.id);
  }
  async _fetchProduct(e) {
    this.dispatchEvent(new CustomEvent(this._events.fetchBefore, { bubbles: !0 }));
    try {
      var t = await (await fetch(`/products/${e}.js`)).json();
      return this.dispatchEvent(new CustomEvent(this._events.fetchAfter, { bubbles: !0 })), t;
    } catch (e) {
      this.dispatchEvent(new CustomEvent(this._events.fetchError, { details: { error: e }, bubbles: !0 }));
    }
  }
  _getDifference(e, t) {
    var s = {};
    if (e || t) {
      if (!e) return t;
      if (!t) return e;
      for (const r in t) t[r] !== e[r] && (s[r] = t[r]);
    }
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((e) => e.removeEventListener("change", this._handleOptionChange));
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), (this.input = this.querySelector("input")), (this.changeEvent = new Event("change", { bubbles: !0 })), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
class LoadingSpinner extends HTMLElement {
  constructor() {
    super();
    var e = document.createElement("template");
    (e.innerHTML = `
    <style>
      :host {
        display: none;
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `),
      this.attachShadow({ mode: "open" }),
      this.shadowRoot.appendChild(e.content.cloneNode(!0));
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.predictiveSearchResults = this.querySelector("[js-predictive-search]")),
      this.input.addEventListener(
        "input",
        theme.utils
          .debounce((e) => {
            this.onChange(e);
          }, 300)
          .bind(this)
      );
  }
  onChange() {
    var e = this.input.value.trim();
    e.length ? this.getSearchResults(e) : this.close();
  }
  getSearchResults(e) {
    fetch(routes.predictive_search_url + `?q=${e}&resources[type]=product,collection,article,page&resources[limit]=4&section_id=predictive-search`)
      .then((e) => {
        if (e.ok) return e.text();
        throw ((e = new Error(e.status)), this.close(), e);
      })
      .then((e) => {
        e = new DOMParser().parseFromString(e, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
        (this.predictiveSearchResults.innerHTML = e), this.open();
      })
      .catch((e) => {
        throw (this.close(), e);
      });
  }
  open() {
    this.predictiveSearchResults.style.display = "block";
  }
  close() {
    this.predictiveSearchResults.style.display = "none";
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { container: "filter-sort", form: "[js-filter-form]", filter: "[js-filter]", clearAll: "[js-clear-all]", sort: "[js-sort]", select: "[js-filter-form-sort]", loader: "loading-spinner" }),
      (this._events = { change: "filter:change" }),
      (this._cache = []),
      (this._debouncedOnSubmit = theme.utils.debounce((e) => {
        this._onSubmitHandler(e);
      }, 500));
  }
  connectedCallback() {
    (this._form = this.querySelector(this._selectors.form)),
      (this._sort = this.querySelectorAll(this._selectors.sort)),
      (this._clearAll = this.querySelector(this._selectors.clearAll)),
      (this._loader = this.querySelector(this._selectors.loader)),
      this._setListeners();
  }
  _setListeners() {
    window.addEventListener("popstate", this._onHistoryChange),
      this._form.addEventListener("input", this._debouncedOnSubmit),
      this._clearAll.addEventListener("click", this._onClearAllHandler),
      document.addEventListener("filter:clearAll", this._onClearAllHandler),
      this._sort.forEach((e) => {
        e.addEventListener("click", this._handleSortOption);
      });
  }
  _renderComponent(e) {
    e = e.querySelector(this._selectors.container);
    theme.utils.refreshElements([this._selectors.filter], e, this);
  }
  _onSubmitHandler = (e) => {
    e.preventDefault();
    (e = new FormData(this._form)), (e = new URLSearchParams(e).toString());
    this._propagateChange(e);
  };
  _onClearAllHandler = (e) => {
    e.preventDefault();
    this._propagateChange("");
  };
  _onHistoryChange = (e) => {
    e = e.state ? e.state.searchParams : FilterSort.searchParamsInitial;
    e !== FilterSort.searchParamsPrev && (this._propagateChange(e, !1), (this._onSubmitHandlerEvent = null));
  };
  _handleSortOption = (e) => {
    var t = this.querySelector(this._selectors.select),
      e = e.currentTarget.value;
    (t.value = e), t.dispatchEvent(new Event("change"));
  };
  async _propagateChange(e, t = !0) {
    this._loader.setAttribute("loading", "");
    const s = window.location.pathname + "?" + e;
    var r = (e) => e.url === s,
      r = this._cache.some(r) ? this._markupFromCache(r) : await this._markupFromFetch(s);
    document.dispatchEvent(new CustomEvent("filter:change", { detail: { parsedHTML: r } })),
      this._renderComponent(r),
      this.querySelectorAll("s-accordion").forEach((e) => {
        e.connectedCallback();
      }),
      t && history.pushState({ searchParams: e }, "", "" + window.location.pathname + (e && "?".concat(e))),
      this._loader.removeAttribute("loading", "");
  }
  _markupFromCache(e) {
    e = this._cache.find(e).html;
    return new DOMParser().parseFromString(e, "text/html");
  }
  _markupFromFetch(s) {
    let r = this._cache;
    return fetch(s)
      .then((e) => e.text())
      .then((e) => {
        var t = new DOMParser().parseFromString(e, "text/html");
        return (r = [...r, { html: e, url: s }]), t;
      });
  }
}
(FilterSort.searchParamsInitial = window.location.search.slice(1)), (FilterSort.searchParamsPrev = window.location.search.slice(1));
class ActiveFilters extends HTMLElement {
  constructor() {
    super(), (this._selectors = { remove: "[js-remove]", clearAll: "[js-clear-all]" }), (this._refresh = ["[js-active-filter]"]);
  }
  connectedCallback() {
    document.addEventListener("filter:change", this._handleFilterChange), this._setListeners();
  }
  _setListeners() {
    var e = this.querySelector(this._selectors.clearAll);
    e && e.addEventListener("click", this._triggerClearAll), this.querySelectorAll(this._selectors.remove).forEach((e) => e.addEventListener("click", this._handleRemove));
  }
  _handleRemove = (e) => {
    e.preventDefault();
    var { name: e, value: t } = e.currentTarget.dataset,
      e = document.querySelector(`filter-sort [name="${e}"][value="${t}"]`);
    e && e.click();
  };
  _handleFilterChange = (e) => {
    (e = e.detail.parsedHTML), (e = e.querySelector("active-filters"));
    (this.innerHTML = e.innerHTML), this._setListeners();
  };
  _triggerClearAll = (e) => {
    e.preventDefault(), e.stopImmediatePropagation(), document.dispatchEvent(new CustomEvent("filter:clearAll"));
  };
}
class PriceRange extends HTMLElement {
  constructor() {
    super(), this.querySelectorAll("input").forEach((e) => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    var e = this.querySelectorAll("input"),
      t = e[0],
      e = e[1];
    e.value && t.setAttribute("max", e.value), t.value && e.setAttribute("min", t.value), "" === t.value && e.setAttribute("min", 0), "" === e.value && t.setAttribute("max", e.getAttribute("max"));
  }
  adjustToValidValues(e) {
    var t = Number(e.value),
      s = Number(e.getAttribute("min")),
      r = Number(e.getAttribute("max"));
    t < s && (e.value = s), r < t && (e.value = r);
  }
}
class Video extends HTMLElement {
  constructor() {
    super(), (this._selectors = { video: "[js-video]", play: "[js-play]" });
  }
  connectedCallback() {
    (this.video = this.querySelector(this._selectors.video)), (this.play = this.querySelector(this._selectors.play)), this.play.addEventListener("click", this._togglePlay);
  }
  _togglePlay = () => {
    this.video.setAttribute("controls", "controls"), this.video.play(), this.play.classList.add("hidden");
  };
}
class ProductCard extends HTMLElement {
  constructor() {
    super(), (this._selectors = { addToCart: "[js-add-to-cart]", atcSelect: "[js-atc-select]", price: "[js-product-card-price]" });
  }
  connectedCallback() {
    (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      (this.addToCart = this.querySelector(this._selectors.addToCart)),
      (this.atcSelect = this.querySelector(this._selectors.atcSelect)),
      (this.prices = this.querySelectorAll(this._selectors.price)),
      this._setupListeners();
  }
  _setupListeners() {
    const waitForAddToCart = setInterval(() => {
      if (this.addToCart !== null) {
        clearInterval(waitForAddToCart);

        this.addToCart.addEventListener("click", this._addToCart);

        if (this.atcSelect !== null) {
          this.atcSelect.addEventListener("change", this._updateVariant);
        }
      }
    }, 50);
  }
  _addToCart = (e) => {
    e.preventDefault(), this._cartAdd(this.addToCart.dataset.variantId);
  };
  _updateVariant = (t) => {
    (this.addToCart.dataset.variantId = t.detail.value),
      this.prices.forEach((e) => {
        e.dataset.value == t.detail.value ? e.classList.remove("hidden") : e.classList.add("hidden");
      }),
      this.addToCart.removeAttribute("disabled");
  };
  _cartAdd(e) {
    e = { items: [{ id: e, quantity: 1 }], sections: this.cart.getSectionsToRender().map((e) => e.id) };
    fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(e) })
      .then((e) => e.json())
      .then((e) => {
        document.querySelector("cart-items") && document.querySelector("cart-items").onCartUpdate(), this.cart.renderContents(e), this.cartDrawer.getAttribute("aria-hidden").includes("true") && this.cartDrawer.open();
      })
      .catch((e) => {
        console.log(e);
      });
  }
}
class Select extends HTMLElement {
  constructor() {
    super(), (this._selectors = { selectDropdown: "select" }), (this.options = { searchEnabled: !1, shouldSort: !1, allowHTML: !0, placeholder: !1, itemSelectText: "" });
  }
  connectedCallback() {
    var e = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    (this.options = Object.assign(this.options, e)), this._initFakeDropdown();
  }
  _initFakeDropdown() {
    var e = this.querySelector(this._selectors.selectDropdown);
    new Choices(e, this.options);
  }
}
customElements.define("s-select", Select),
  customElements.define("product-card", ProductCard),
  customElements.define("s-video", Video),
  customElements.define("s-squiggly", Squiggly),
  customElements.define("s-drawer", Drawer),
  customElements.define("s-modal", Modal),
  customElements.define("s-accordion", Accordion),
  customElements.define("s-tabs", Tabs),
  customElements.define("s-carousel", Carousel),
  customElements.define("cart-remove-button", CartRemoveButton),
  customElements.define("cart-items", CartItems),
  customElements.define("cart-note", CartNote),
  customElements.define("cart-drawer", CartDrawer),
  customElements.define("cart-drawer-items", CartDrawerItems),
  customElements.define("s-header", SiteHeader),
  customElements.define("product-options", ProductOptions),
  customElements.define("quantity-input", QuantityInput),
  customElements.define("loading-spinner", LoadingSpinner),
  customElements.define("predictive-search", PredictiveSearch),
  customElements.define("filter-sort", FilterSort),
  customElements.define("active-filters", ActiveFilters),
  customElements.define("price-range", PriceRange);
class CollectionGrid extends HTMLElement {
  constructor() {
    super(), (this._selectors = { productGrid: "[js-products-grid]", toggleGrid: "[js-toggle-grid]", filterSort: "[js-filter-sort]" }), (this._refresh = ["[js-products-grid]"]), (this._cache = []);
  }
  connectedCallback() {
    this._setListeners();
  }
  _setListeners() {
    document.addEventListener("filter:change", this._handleFilterChange);
  }
  _handleFilterChange = (e) => {
    (e = e.detail.parsedHTML), (e = e.querySelector(`[data-id="${this.dataset.id}"]`));
    theme.utils.refreshElements(this._refresh, e, this);
  };
}
class ProductMain extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        error: "[js-error-message]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        label: "[js-swatch-label]",
        imagesContainer: "[js-images-container]",
        mainCarousel: "[js-main-carousel]",
        thumbnailCarousel: "[js-thumbnail-carousel]",
        thumbnailSlide: "[js-thumbs-carousel-slide]",
        paginationBullet: "[js-swiper-pagination-bullet]",
      }),
      (this.thumbOptions = { direction: "vertical", spaceBetween: 16, slideToClickedSlide: !1, watchSlidesVisibility: !0, watchSlidesProgress: !0, cssMode: !0 });
  }
  connectedCallback() {
    (this.mainCarousel = this.querySelector(this._selectors.mainCarousel)),
      (this.thumbnailCarousel = this.querySelector(this._selectors.thumbnailCarousel)),
      (this.thumbnailSlides = this.querySelectorAll(this._selectors.thumbnailSlide)),
      (this.paginationBullets = this.querySelectorAll(this._selectors.paginationBullet)),
      (this.buttons = this.querySelectorAll(this._selectors.addToCart)),
      (this.swatchLabels = this.querySelectorAll(this._selectors.label)),
      this.addEventListener("variant:change", this._handleVariantChange),
      "true" == this.dataset.sizes && ((this.currentSize = ""), (this.sizeOptionPosition = this.dataset.sizeOptionPosition)),
      this._initProductForm(),
      this._imageCarousel(),
      this._thumbnailCarousel();
  }
  _initProductForm() {
    (this.form = this.querySelector(this._selectors.form)), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), (this.cart = document.querySelector("cart-drawer")), (this.cartDrawer = document.querySelector("#CartDrawer"));
  }
  _imageCarousel() {
    this.mainCarousel.querySelectorAll(".product__slide").forEach((e) => {
      e.classList.contains("swiper-slide") && this.mainCarousel.querySelector(".swiper-wrapper").appendChild(e);
    }),
      this.mainCarousel.swiper.destroy();
    var e = { slidesPerView: 1, loop: !0, autoHeight: !0, watchSlidesProgress: !0, thumbs: { swiper: this.thumbnailCarousel }, breakpoints: { 0: { pagination: { el: ".product-pagination", clickable: !0 } }, 768: { pagination: !1 } } };
    new Swiper(this.mainCarousel, e);
  }
  _thumbnailCarousel() {
    this.thumbnailCarousel.querySelectorAll(".thumbnail__slide").forEach((e) => {
      e.classList.contains("swiper-slide-thumb") && this.thumbnailCarousel.querySelector(".swiper-wrapper").appendChild(e);
    }),
      this.thumbnailCarousel.swiper.destroy();
    var e = new Swiper(this.thumbnailCarousel, this.thumbOptions);
    let s = this.mainCarousel.swiper;
    e.on("click", function(e, t) {
      e = e.clickedIndex;
      s.slideTo(e, 300, !0);
    });
  }
  onSubmitHandler(e) {
    e.preventDefault(), this.handleErrorMessage(), this._disableButtons();
    e = { method: "POST", headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" } };
    const t = new FormData(this.form);
    this.cart &&
      (t.append(
        "sections",
        this.cart.getSectionsToRender().map((e) => e.id)
      ),
        t.append("sections_url", window.location.pathname),
        this.cart.setActiveElement(document.activeElement)),
      (e.body = t),
      fetch("" + window.routes.cart_add_url, e)
        .then((e) => e.json())
        .then((e) => {
          e.status
            ? (theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, { source: "product-form", productVariantId: t.get("id"), errors: e.errors || e.description, message: e.message }),
              this.handleErrorMessage(e.description),
              (this.error = !0))
            : this.cart
              ? (this.error || theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: t.get("id") }), (this.error = !1), this.cart.renderContents(e), this.cartDrawer.open())
              : (window.location = window.routes.cart_url);
        })
        .catch((e) => {
          this.handleErrorMessage(e.description), console.error(e);
        })
        .finally(() => {
          this._enableButtons();
        });
  }
  handleErrorMessage(e = !1) {
    (this.errorMessageWrapper = this.querySelector(this._selectors.error)), e ? ((this.errorMessageWrapper.innerHTML = e), this.errorMessageWrapper.classList.remove("hidden")) : this.errorMessageWrapper.classList.add("hidden");
  }
  _handleVariantChange = (e) => {
    var { variant: t, priceChange: s } = e.detail;
    this._updateAddToCartState(t),
      this._updateLabels(),
      "true" == this.dataset.sizes &&
      e.target._lastSelectedOption.key == this.sizeOptionPosition &&
      this.currentSize != e.target._lastSelectedOption.value &&
      ((e = e.target._lastSelectedOption.value), this._updateMediaSlides(e), (this.currentSize = e)),
      t && s && this._updatePrice(t);
  };
  _updateLabels = () => {
    this.swatchLabels.forEach((e) => {
      e.classList.contains("product-label-selected") && e.classList.remove("product-label-selected");
    });
  };
  _themeFormatMoney = (amount, format) => {
    amount = (amount / 100).toFixed(2);
    return format.replace("{{amount}}", amount);
  }
  _updateAddToCartState(e) {
    var t = this.querySelectorAll(this._selectors.addToCart);
    var shopifyCurrencyFormat = window.shopifyCurrencyFormat || "${{amount}}";

    e
      ? e.available
        ? t.forEach((atc) => {

          atc.textContent = "Add To Cart";
          atc.removeAttribute("disabled");

          //@CL Create a new <span> for the selected variant price and append to add to cart button
          const priceSpanSelector = 'span.single-purchase-variant-price';
          const existingSpan = atc.querySelector(priceSpanSelector);
          if (existingSpan) {
            existingSpan.remove();
          }
          const priceSpan = document.createElement('span');
          priceSpan.className = "single-purchase-variant-price";
          priceSpan.textContent = ` - ${this._themeFormatMoney(e.price, shopifyCurrencyFormat)}`;
          atc.appendChild(priceSpan);
        })
        : t.forEach((e) => {
          (e.textContent = "Sold out"), e.setAttribute("disabled", "");
        })
      : t.forEach((e) => {
        (e.textContent = "Unavailable"), e.setAttribute("disabled", "");
      });
  }
  _updateMediaSlides = (t) => {
    var e = this.querySelectorAll("[js-thumbs-carousel-slide]"),
      s = this.querySelectorAll("[js-main-carousel-slide]");
    const r = this.querySelector(this._selectors.imagesContainer).dataset.title;
    e.forEach((e) => {
      e.classList.remove("hidden", "swiper-slide", "swiper-slide-thumb", "swiper-slide-thumb-active"),
        (e.dataset.size && e.dataset.size == t) || e.dataset.size == r ? (e.classList.add("swiper-slide", "swiper-slide-thumb"), e.setAttribute("js-carousel-slide", "")) : (e.classList.add("hidden"), e.removeAttribute("js-carousel-slide"));
    }),
      s.forEach((e) => {
        e.classList.remove("hidden", "swiper-slide", "swiper-slide-active"),
          (e.dataset.size && e.dataset.size == t) || e.dataset.size == r ? (e.classList.add("swiper-slide"), e.setAttribute("js-carousel-slide", "")) : (e.classList.add("hidden"), e.removeAttribute("js-carousel-slide"));
      }),
      this._imageCarousel(),
      this._thumbnailCarousel();
  };
  _updatePrice(e) { }
  _disableButtons() {
    this.buttons.forEach((e) => {
      e.setAttribute("disabled", "");
      e = e.querySelector(this._selectors.loader);
      e && e.setAttribute("loading", "");
    });
  }
  _enableButtons() {
    this.buttons.forEach((e) => {
      e.removeAttribute("disabled");
      e = e.querySelector(this._selectors.loader);
      e && e.removeAttribute("loading");
    });
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    new IntersectionObserver(
      ((e, t) => {
        e[0].isIntersecting &&
          (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                var t = document.createElement("div"),
                  e = ((t.innerHTML = e), t.querySelector("product-recommendations"));
                e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML);
              })
              .catch((e) => {
                console.error(e);
              }));
      }).bind(this),
      { rootMargin: "0px 0px 200px 0px" }
    ).observe(this);
  }
}
class Blog extends HTMLElement {
  constructor() {
    super(), (this._selectors = { dropdownContainer: "[js-dropdown-container]", dropdownSelection: "[js-dropdown-selection]", dropdownOptions: "[js-dropdownOptions]" });
  }
  connectedCallback() {
    (this.current = !1), (this.event = !1), (this.containers = document.querySelectorAll(this._selectors.dropdownContainer)), this._setListeners();
  }
  _setListeners() {
    this.containers.forEach((s) => {
      console.log(s),
        s.addEventListener("click", (e) => {
          var t;
          s.querySelector(this._selectors.dropdownSelection).contains(e.target) &&
            ((t = "closed" === s.dataset.dropdownState), (s.dataset.dropdownState = t ? "open" : "closed"), this.current && (this.current.dataset.dropdownState = "closed"), (this.current = t && s), (this.event = e));
        });
    }),
      window.addEventListener("click", (e) => {
        this.current && e !== this.event && ((this.current.dataset.dropdownState = "closed"), (this.current = !1), (this.event = !1));
      });
  }
}
class Media extends HTMLElement {
  constructor() {
    super(), (this._selectors = { dropdown: "[js-dropdown]", dropdownHeader: "[js-dropdown-header]", dropdownHeaderText: "[js-dropdown-header-text]", dropdownItems: "[js-dropdown-item]", mediaItem: "[js-media-item]" });
  }
  connectedCallback() {
    (this.dropdown = this.querySelector(this._selectors.dropdown)),
      (this.dropdownHeader = this.querySelector(this._selectors.dropdownHeader)),
      (this.dropdownHeaderText = this.querySelector(this._selectors.dropdownHeaderText)),
      (this.dropdownItems = this.querySelectorAll(this._selectors.dropdownItems)),
      (this.allItems = this.querySelectorAll(this._selectors.mediaItem)),
      this._setListeners();
  }
  _setListeners() {
    this.dropdown.addEventListener("mouseleave", this._closeDropdown),
      this.dropdownHeader.addEventListener("click", this._dropdownHandler),
      this.dropdownItems.forEach((e) => {
        e.addEventListener("click", this._dropdownSelectHandler);
      });
  }
  _dropdownHandler = () => {
    this.dropdown.classList.contains("Media__Categories-Dropdown--open") ? this._closeDropdown() : this._openDropdown();
  };
  _closeDropdown = () => {
    this.dropdown.classList.remove("Media__Categories-Dropdown--open");
  };
  _openDropdown = () => {
    this.dropdown.classList.add("Media__Categories-Dropdown--open");
  };
  _dropdownSelectHandler = (e) => {
    var e = e.target.parentNode,
      t = e.dataset.title,
      e = e.id.split("--")[1];
    "all" == e ? this._showAllFeed() : this._showSelected(e), this._updateDropdownUI(e, t);
  };
  _showAllFeed = () => {
    this.allItems.forEach((e) => {
      e.style.display = "block";
    });
  };
  _showSelected = (s) => {
    this.allItems.forEach((e) => {
      var t = e.dataset.type;
      e.style.display = t == s ? "block" : "none";
    });
  };
  _updateDropdownUI = (t, e) => {
    this.dropdownItems.forEach((e) => {
      e.id.split("--")[1] == t ? e.classList.add("Media-CD__item--selected") : e.classList.remove("Media-CD__item--selected");
    }),
      (this.dropdownHeaderText.innerHTML = e),
      this._closeDropdown();
  };
}
class MainSearch extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.productCards = this.querySelectorAll(".search-grid-item--products")),
      (this.articleCards = this.querySelectorAll(".search-grid-item--articles")),
      (this.pageCards = this.querySelectorAll(".search-grid-item--pages")),
      (this.filters = this.querySelectorAll(".Search__results-filter")),
      this._setListeners();
  }
  _setListeners = (e) => {
    this.filters.forEach((t) => {
      t.addEventListener("click", (e) => this.filterHandler(t.id));
    });
  };
  filterHandler = (s) => {
    var e = s.split("--")[1];
    "products" == e && this.showProducts(),
      "articles" == e && this.showArticles(),
      "pages" == e && this.showPages(),
      "all" == e && this.showAll(),
      this.filters.forEach((e) => {
        var t = s.split("--")[1];
        e.id == s ? e.classList.add("Search__results-filter--selected") : (console.log(t), e.classList.remove("Search__results-filter--selected"));
      });
  };
  showAll = () => {
    this.productCards.forEach((e) => {
      e.classList.remove("hidden");
    }),
      this.articleCards.forEach((e) => {
        e.classList.remove("hidden");
      }),
      this.pageCards.forEach((e) => {
        e.classList.remove("hidden");
      });
  };
  showProducts = () => {
    this.productCards.forEach((e) => {
      e.classList.remove("hidden");
    }),
      this.articleCards.forEach((e) => {
        e.classList.add("hidden");
      }),
      this.pageCards.forEach((e) => {
        e.classList.add("hidden");
      }),
      AOS.refresh();
  };
  showArticles = () => {
    this.productCards.forEach((e) => {
      e.classList.add("hidden");
    }),
      this.articleCards.forEach((e) => {
        e.classList.remove("hidden");
      }),
      this.pageCards.forEach((e) => {
        e.classList.add("hidden");
      }),
      AOS.refresh();
  };
  showPages = () => {
    this.productCards.forEach((e) => {
      e.classList.add("hidden");
    }),
      this.articleCards.forEach((e) => {
        e.classList.add("hidden");
      }),
      this.pageCards.forEach((e) => {
        e.classList.remove("hidden");
      }),
      AOS.refresh();
  };
}

class TextCarousel extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      prevButton: "[js-carousel-prev]",
      nextButton: "[js-carousel-next]",
      pagination: "[js-swiper-bullet]",
      carousel: "[js-carousel]",
    };

    this.options = {
      grabCursor: true,
      centeredSlides: false,
      slideToClickedSlide: true,
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        900: { slidesPerView: 1.5, spaceBetween: 50 },
      },
    };

    this._handleResize = this._handleResize.bind(this);
  }

  connectedCallback() {
    this.prevButton = this.querySelector(this._selectors.prevButton);
    this.nextButton = this.querySelector(this._selectors.nextButton);

    this.prevButton?.addEventListener("click", this._prevSlide);
    this.nextButton?.addEventListener("click", this._nextSlide);

    this._initCarousel();

    window.addEventListener("resize", this._handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._handleResize);
  }

  _initCarousel() {
    const carouselElement = this.querySelector(this._selectors.carousel);
    const carouselSelector = "#" + carouselElement.id;
    const desktopPagination = this.querySelector(".desktop-pagination");
    const mobilePagination = this.querySelector(".mobile-pagination");

    const setPagination = () => {
      const isDesktop = window.matchMedia("(min-width: 900px)").matches;
      this.pagination = isDesktop
        ? desktopPagination.querySelectorAll("[js-swiper-bullet]")
        : mobilePagination.querySelectorAll("[js-swiper-bullet]");

      this.pagination.forEach((bullet) => {
        bullet.removeEventListener("click", this._slideToPagination);
        bullet.addEventListener("click", this._slideToPagination);
      });

      // @CL - Enhance pagination bullets for accessibility.
      this.pagination.forEach((bullet, index) => {
        const slideNumber = index + 1;
        bullet.dataset.index = index;

        bullet.setAttribute("role", "button");
        bullet.setAttribute("tabindex", "0");
        bullet.setAttribute("aria-label", `Go to slide ${slideNumber}`);

        const existingScreenReaderBulletText = bullet.querySelector(".sr-only");

        if (existingScreenReaderBulletText) {
          bullet.removeChild(existingScreenReaderBulletText);
        }

        const screenReaderBulletText = document.createElement("span");
        screenReaderBulletText.className = "sr-only";
        screenReaderBulletText.textContent = `Go to slide ${slideNumber}`;

        bullet.appendChild(screenReaderBulletText);
      });
    };

    const initSwiper = () => {
      this.carousel = new Swiper(carouselSelector, this.options);
      this.carousel.on("slideChange", this._updatePagination);
      setPagination();
    };

    if (this.dataset.init !== undefined) {
      enquire.register(theme.config.mediaQueries[this.dataset.init], {
        match: () => {
          initSwiper.call(this);
        },
        unmatch: function () {
          if (this.carousel?.el?.classList.contains("swiper-initialized")) {
            this.carousel.destroy(true, true);
          }
        }.bind(this),
      });
    } else {
      initSwiper.call(this);
    }

    this._setPagination = setPagination;
  }

  _handleResize() {
    clearTimeout(this._resizeTimeout);

    this._resizeTimeout = setTimeout(() => {
      if (!this.carousel) return;

      this._setPagination?.();
      this._updatePagination();
    }, 200);
  }

  _prevSlide = () => {
    this.carousel?.slidePrev();
  };

  _nextSlide = () => {
    this.carousel?.slideNext();
  };

  _slideToPagination = (e) => {
    const index = e.currentTarget?.dataset?.index;

    if (index !== undefined) {
      this.carousel.slideTo(parseInt(index, 10), 500, false);
      this._updatePagination();
    }
  };

  _updatePagination = () => {
    const activeIndex = this.carousel.activeIndex;

    this.pagination?.forEach((bullet) => {
      bullet.classList.toggle("swiper-pagination-bullet-active", parseInt(bullet.dataset.index, 10) === activeIndex);
    });
  };
}

customElements.define("s-collection-grid", CollectionGrid),
customElements.define("s-blog", Blog),
customElements.define("s-media", Media),
customElements.define("main-search", MainSearch),
customElements.define("s-text-carousel", TextCarousel),
customElements.define("s-product", ProductMain),
customElements.define("product-recommendations", ProductRecommendations);

class Account extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addressCountrySelect: "[js-country-select]",
        editAddressModal: "[js-edit-address-modal]",
        editAddressOpen: "[js-edit-address]",
        editAddressForm: "[js-edit-address-form]",
        deleteAddressButton: "[js-delete-address]",
        ordersContainer: "[js-orders]",
        ordersPagination: "[js-next-page]",
        order: "[js-order]",
      });
  }
  connectedCallback() {
    (this.countrySelects = this.querySelectorAll(this._selectors.addressCountrySelect)),
      (this.editAddressModal = this.querySelector(this._selectors.editAddressModal)),
      (this.openEditAddress = this.querySelectorAll(this._selectors.editAddressOpen)),
      (this.editAddressForms = this.querySelectorAll(this._selectors.editAddressForm)),
      (this.deleteAddressButtons = this.querySelectorAll(this._selectors.deleteAddressButton)),
      (this.ordersContainer = this.querySelector(this._selectors.ordersContainer)),
      (this.ordersPagination = this.querySelector(this._selectors.ordersPagination)),
      (this.manageAddressContainer = this.querySelector("#manageAddressContainer")),
      (this.manageAddressButton = this.querySelector("#manageAddressButton")),
      (this.accountContainer = this.querySelector("#accountContainer")),
      (this.returnToAddressButton = this.querySelector("#returnToAddressButton")),
      (this.addNewAddressFormContainer = this.querySelector("#addNewAddressFormContainer")),
      (this.addNewAddressButton = this.querySelector("#addNewAddressButton")),
      (this.cancelNewAddressButton = this.querySelector("#cancelNewAddressButton")),
      (this.editAddressButtonArray = this.querySelectorAll(".edit-address-btn")),
      (this.editAddressFormArray = this.querySelectorAll(".edit-address-form")),
      (this.editAddressCancelButtonArray = this.querySelectorAll(".edit-address-cancel-btn")),
      this._setupCountries(),
      this._setupEventListeners(),
      this._setupEditAddressEventListeners();
  }
  _setupCountries() {
    Shopify &&
      Shopify.CountryProvinceSelector &&
      (new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
        this.countrySelects.forEach((e) => {
          e = e.dataset.formId;
          new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, { hideElement: "AddressProvinceContainer_" + e });
        }));
  }
  _setupEditAddressEventListeners() {
    for (let e = 0; e < this.editAddressFormArray.length; e++) {
      var t = this.editAddressFormArray[e].attributes["data-form-id"].value;
      const s = this.editAddressFormArray[e];
      for (let e = 0; e < this.editAddressButtonArray.length; e++)
        t === this.editAddressButtonArray[e].attributes["data-form-id"].value &&
          this.editAddressButtonArray[e].addEventListener("click", function(e) {
            s.classList.contains("hidden") ? s.classList.remove("hidden") : s.classList.add("hidden");
          });
      for (let e = 0; e < this.editAddressCancelButtonArray.length; e++)
        t === this.editAddressCancelButtonArray[e].attributes["data-form-id"].value &&
          this.editAddressCancelButtonArray[e].addEventListener("click", function(e) {
            s.classList.contains("hidden") ? s.classList.remove("hidden") : s.classList.add("hidden");
          });
    }
  }
  _setupEventListeners() {
    this.ordersPagination && this.ordersPagination.addEventListener("click", this._addOrders),
      this.openEditAddress.forEach((e) => {
        e.addEventListener("click", this._handleOpenEditAddress);
      }),
      this.deleteAddressButtons.forEach((e) => {
        e.addEventListener("click", this._handleDeleteAddress);
      }),
      this.editAddressModal.addEventListener("close", this._handleCloseEditAddress),
      this.manageAddressButton.addEventListener("click", this._handleManageAddressOpen),
      this.returnToAddressButton.addEventListener("click", this._handleManageAddressClose),
      this.addNewAddressButton.addEventListener("click", this._handleAddNewAddress),
      this.cancelNewAddressButton.addEventListener("click", this._handleCancelNewAddress);
  }
  _addOrders = async () => {
    var e = this.ordersPagination.dataset.url,
      e = await this._getOrders(e),
      t = e.querySelector(this._selectors.ordersContainer).innerHTML,
      e = e.querySelector(this._selectors.ordersPagination);
    this.ordersContainer.insertAdjacentHTML("beforeend", t), e ? (this.ordersPagination.dataset.url = e.dataset.url) : this.ordersPagination.remove(), this.ordersContainer.connectedCallback();
  };
  _getOrders(e) {
    return fetch(e)
      .then((e) => e.text())
      .then((e) => {
        return new DOMParser().parseFromString(e, "text/html");
      });
  }
  _handleOpenEditAddress = (e) => {
    e.stopPropagation();
    (e = e.currentTarget.dataset.form), (e = document.querySelector("#address_form_" + e));
    e.classList.remove("hidden"), this.editAddressModal.open(), e.querySelector('[name="address[first_name]"]').focus();
  };
  _handleDeleteAddress = (e) => {
    e = e.currentTarget.dataset.target;
    confirm("Are you sure you want to delete this address?") && Shopify.postLink(e, { parameters: { _method: "delete" } });
  };
  _handleCloseEditAddress = (e) => {
    this.editAddressForms.forEach((e) => {
      e.classList.add("hidden");
    });
  };
  _handleManageAddressOpen = (e) => {
    this.manageAddressContainer.classList.remove("hidden"), this.accountContainer.classList.add("hidden");
  };
  _handleManageAddressClose = (e) => {
    this.manageAddressContainer.classList.add("hidden"), this.accountContainer.classList.remove("hidden");
  };
  _handleAddNewAddress = (e) => {
    this.addNewAddressButton.classList.add("hidden"), this.addNewAddressFormContainer.classList.remove("hidden");
  };
  _handleCancelNewAddress = (e) => {
    this.addNewAddressFormContainer.classList.add("hidden"), this.addNewAddressButton.classList.remove("hidden");
  };
}
customElements.define("s-account", Account);
